import { useContext } from 'react';
import { EMPTY_OBJECT } from '../../consts/empty';
import { DrawerContext, type DrawerContextType } from './drawerContext';

export const useDrawer = (): DrawerContextType => {
  const context = useContext(DrawerContext);

  if (!context) {
    return EMPTY_OBJECT;
  }

  return context;
};
